module.exports = __webpack_public_path__ + "img/interior1.1d18f604.png";